export default __webpack_public_path__ + "static/media/Todolist.87e2c4f3.png";